import { LandingPage } from './components/LandingPage';
import { PostRedirect } from './components/PostRedirect';
import { resolveLegalPage } from './pages/legalRoutes';

// Match /post/<UUID> — no React Router dependency needed.
const POST_PATH_REGEX = /^\/post\/([0-9a-f-]{36})$/i;
/** Capture any single path segment; decode so encoded usernames (e.g. dots) match validation. */
const PROFILE_PATH_REGEX = /^\/profile\/([^/]+)\/?$/;
const postMatch = window.location.pathname.match(POST_PATH_REGEX);
const profileRaw = window.location.pathname.match(PROFILE_PATH_REGEX)?.[1];
let profileUsernameDecoded: string | undefined;
if (profileRaw) {
  try {
    profileUsernameDecoded = decodeURIComponent(profileRaw);
  } catch {
    profileUsernameDecoded = undefined;
  }
}

const legalPageRender = resolveLegalPage(window.location.pathname);

function App() {
  if (postMatch?.[1]) {
    return <PostRedirect postId={postMatch[1]} />;
  }
  if (profileUsernameDecoded) {
    return <PostRedirect profileUsername={profileUsernameDecoded} />;
  }
  if (legalPageRender) {
    const LegalPage = legalPageRender;
    return <LegalPage />;
  }

  return (
    <div className="min-h-dynamic-screen max-md:h-[100svh] max-md:overflow-hidden bg-background-light text-[#111818] selection:bg-primary/30">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <main
        id="main-content"
        className="relative min-h-dynamic-screen max-md:h-[100svh] max-md:min-h-0 max-md:overflow-hidden"
        role="main"
        tabIndex={-1}
      >
        {/* Hero Background Glow */}
        <div
          className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full hero-glow pointer-events-none"
          aria-hidden="true"
        ></div>

        <LandingPage />
      </main>
    </div>
  );
}

export default App;
